import PROJECTS from "../../../constants/projects";
import ProjectCard from "../../../components/ProjectCard/ProjectCard";
import { SECTIONIDS } from "../../../constants/sectionId";

type Props = {};

const ProjectsSection = (props: Props) => {
  const isOdd = PROJECTS.length % 2 === 1;
  return (
    <section id={SECTIONIDS.WORK} className="relative z-10 bg-black pb-20 lg:pt-0">
      <div className="mx-auto max-w-7xl px-6 lg:px-12 xl:px-6 2xl:px-0">
        <div
          data-rellax-speed="-3"
          data-rellax-xs-speed="0"
          data-rellax-mobile-speed="0"
          className="rellax flex flex-wrap items-center gap-6"
          style={{ transform: "translate3d(0px,0px,0px)" }}
        >
          <h2 className="text-7xl font-bold text-white xl:text-8xl">
            Our work
          </h2>
          <span className="h-max rounded-full border border-white/40 px-2 py-1 text-xs tracking-wider text-white">
            {PROJECTS.length} Projects
          </span>
        </div>
        <div className="relative mt-20 gap-20 gap-x-6 space-y-20 sm:grid sm:grid-cols-2 sm:space-y-0 md:mt-72 lg:mt-60">
          {PROJECTS.map((project, index) => {
            // If odd and last project, add col-start-2
            const extraClass = isOdd && index === PROJECTS.length - 1 ? "sm:col-start-2" : "";
            return <ProjectCard project={project} index={index} key={index} extraClass={extraClass} />;
          })}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
